<template>
	<div class="w-100">
		<header>
      <transition name="fade">
        <div class="position-relative z-index-1036">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-table w-100 nav-bottom" style="top:0">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-12 position-relative">
                    <div class="bg-white px-5 py-3" :class="{'box-shadow-nav-desktop':scrollPosition > 100}" style="height: 72px;">
                    	<div class="px-3">
                    		<div class="row">
								    			<div class="col-2">
								    				<template v-if="logo == 'PORTRAIT'">
									    				<router-link :to="'/'+getMerchant().code+'/booking'">
						                    <img :src="getMerchant().image_url" class="position-absolute d-block be_logo_vertical mt-0">
						                  </router-link>
								    				</template>
								    				<template v-else>
									    				<router-link :to="'/'+getMerchant().code+'/booking'">
						                    <img :src="getMerchant().image_url" class="position-absolute d-block be_logo_horizontal">
						                  </router-link>
								    				</template>
								    			</div>
								    			<div class="col-8 text-center">
								    				<div class="mt-1">

								    					<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center" :class="{'bg-green':cart_step == 1}">
									    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-white':cart_step == 1}">1</p>
									    				</div>
									    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block">{{$t('hotel.order')}}</p>
									    				<div class="rounded-4 d-inline-block position-relative" style="border-top: 3px dashed #eee;width: 44px;top: -2px;"></div>

									    				<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center" :class="{'bg-green':cart_step == 2}">
									    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-white':cart_step == 2}">2</p>
									    				</div>
									    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block">{{$t('hotel.payment')}}</p>
									    				<div class="rounded-4 d-inline-block position-relative" style="border-top: 3px dashed #eee;width: 44px;top: -2px;"></div>
									    				
									    				<template v-if="cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'">
										    				<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center" :class="{'bg-orange':cart_step == 'waiting' || cart_step == 'being_processed','bg-orange-soft': cart_step == 'w_confirm'}">
										    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-white':cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'}">3</p>
										    				</div>
										    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block" v-if="cart_step == 'waiting'">{{$t('hotel.waiting.waiting-payment')}}</p>
										    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block" v-if="cart_step == 'w_confirm'">Waiting Confirmation</p>
										    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block" v-if="cart_step == 'being_processed'">{{$t('hotel.waiting.being-processed')}}</p>

										    				<div class="rounded-4 d-inline-block position-relative" style="border-top: 3px dashed #eee;width: 44px;top: -2px;"></div>
									    				</template>

									    				<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center" :class="{'bg-green':cart_step == 3, 'bg-danger':cart_step == 'failed'}">
									    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-white':cart_step == 3}">
									    						<span v-if="cart_step == 1 || cart_step == 2 || cart_step == 3">3</span>
									    						<span class="text-white" v-if="cart_step == 'failed'">3</span>
									    						<span v-if="cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'">4</span>
									    					</p>
									    				</div>
									    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block" v-if="cart_step == 1 || cart_step == 2 || cart_step == 3 || cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'">{{$t('hotel.complete')}}</p> 
									    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block" v-if="cart_step == 'failed'">{{$t('hotel.failed.reservation-failed')}}</p>
								    				</div>
								    			</div>
								    			<div class="col-2 text-right">
								    				<router-link :to="'/'+getMerchant().code+'/account'">
									    				<div @click="setActiveRoute('cart')">
									              <img 
									              	v-if="!isNotLogin()" style="padding: 2px"
									              	:src="getCurrentUser().avatar" 
									              	width="40" 
									              	height="40" 
									              	class="rounded-100 border-2-green object-fit"> 
									              <img 
									              	v-else
									              	src="../../../../assets/img/icon/user.png" 
									              	width="40" 
									              	height="40" 
									              	class="rounded-100 p-1 object-fit" 
									              	style="background-color: #cfcfcf">
									            </div>
									          </router-link>
								    			</div>
								    		</div>
                    	</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </header>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	export default{
		props:{
			cart_step:{
				default: 1
			}
		},
		data(){
			return{
    		scrollPosition: null,
			}
		},
		computed:{
			logo(){
				return this.getMerchant().image_orientation
			}
		},
		methods: {
			...mapGetters(['getMerchant','isNotLogin','getCurrentUser']),
			...mapMutations(['setActiveRoute']),
			updateScroll() {
        this.scrollPosition = window.scrollY
      },
		},
		mounted() {
      window.addEventListener('scroll', this.updateScroll);
		}
	}
</script>
<style scoped>
	
	@media screen and (max-width: 992px) {
		.px-5{
			padding-left: 0!important;
			padding-right: 0!important;
		}
	}

	@media screen and (max-width: 1200px) {
		.px-5{
			padding-left: 0.5rem!important;
			padding-right: 0.5rem!important;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/cartHeader.vue